import { Component, OnInit, ViewChild } from '@angular/core';
import { FILE_UPLOADER } from 'src/app/componentes/file-uploader/file-uploader.component';
import { LgpdService } from 'src/app/service/lgpd/lgpd.service';
import { AuthService } from 'src/app/service/autenticacao/auth.service';
import { Router } from '@angular/router';
import { OK_MANIFESTO_ENVIADO, ERRO_DADOS_NAO_GRAVADOS, ERRO_DADOS_OBRIGATORIOS } from 'src/app/tools/Mensagens';
import { PAGINA_SUCESSO_FORM } from 'src/app/tools/URL';
import { LgpdVO } from 'src/app/entity/LgpdVO';
import { AbstractControl } from '@angular/forms';
import { SolicitacoesInformacoesLgpdComponent } from './solicitacoes-informacoes-lgpd/solicitacoes-informacoes-lgpd.component';

@Component({
  selector: 'lgpd',
  templateUrl: './lgpd.component.html',
  styleUrls: ['./lgpd.component.css']
})
export class LgpdComponent implements OnInit {
  @ViewChild(FILE_UPLOADER, { static: false }) fileUploader;
  @ViewChild(SolicitacoesInformacoesLgpdComponent, { static: false }) solicitacao: SolicitacoesInformacoesLgpdComponent;
  charNum = 5000;
  anexosPreenchidos: boolean = false;

  constructor(public service: LgpdService,
    public authService: AuthService,
    private router: Router) { }

  ngOnInit() {

    this.service.carregarDados().subscribe(retorno => {
      this.service.lgpd.controls.nome.setValue(this.authService.usuarioDTO.nome);
      this.service.lgpd.controls.email.setValue(this.authService.usuarioDTO.email);
      if (retorno) {
        this.service.lgpd.controls.listaClassificacaoCompleta.setValue(retorno.listaClassificacaoCompleta);
        this.service.lgpd.controls.assuntos.setValue(retorno.assuntos);
        this.checarAssuntoUnico();
      }
    })
  }

  checarAssuntoUnico() {
    if (this.service.lgpd.controls.assuntos.value != null && this.service.lgpd.controls.assuntos.value.length == 1) {
      this.changeAssunto(this.service.lgpd.controls.assuntos.value[0]);
    }
  }

  onSubmit() {
    // if (this.service.lgpd.value.assunto) {
    this.preencherDados();
    console.log(this.service.lgpd.controls)
    if (this.service.lgpd.valid && this.anexosPreenchidos) {
      this.service.enviar(this.service.lgpd.value).subscribe(retorno => {
        if (retorno) {
          alert(OK_MANIFESTO_ENVIADO);
          this.router.navigate([PAGINA_SUCESSO_FORM]);
        } else {
          alert(ERRO_DADOS_NAO_GRAVADOS);
        }
      });
    } else {
      const campos = this.tratarMensagemDeErro();
      if(this.anexosPreenchidos) {
        alert(ERRO_DADOS_OBRIGATORIOS + campos);
      }
      else {
        alert("Formulário não está válido. Os anexos do requerente são obrigatórios.");
      }
    }
    // }
    // else {
    //   alert(ERRO_ASSUNTO_OBRIGATORIO);
    // }
  }

  preencherDados() {
    this.service.lgpd.controls.nome.setValue(this.authService.usuarioDTO.nome)
    this.service.lgpd.controls.email.setValue(this.authService.usuarioDTO.email)
    this.service.lgpd.controls.cpf.setValue(this.authService.usuarioDTO.cpfcnpj)
    this.service.lgpd.controls.dataNascimento.setValue(this.authService.usuarioDTO.dataNascimento)
    this.service.lgpd.controls.username.setValue(this.authService.usuarioDTO.username)

    this.service.lgpd.value.files = [];
    this.service.lgpd.value.identificacaoTitular = [];
    this.service.lgpd.value.fotoRequerente = [];
    this.service.lgpd.value.documentoLegal = [];

    this.service.validarDataNascimento(this.service.lgpd.controls.dataNascimento.value)

    // Se o requerente for o titular, são obrigatórios os anexos de doc. de identificação e foto
    if (this.service.lgpd.value.requerente === 'Titular dos Dados') {
      this.service.preencherAnexosTitular(this.solicitacao.titularDados);
      this.anexosPreenchidos = this.service.validarAnexos(2)
    }
    // Se o requerente for um representante legal, todos os anexos são obrigatórios (identificação, foto, procuração)
    else if (this.service.lgpd.value.requerente === 'Representante Legal') {
      this.service.validarDataNascimento(this.service.lgpd.controls.representanteLegal.get('dataNascimento').value)
      this.service.preencherAnexosRepresentanteLegal(this.solicitacao.representanteLegal);
      this.anexosPreenchidos = this.service.validarAnexos(3)
    }

    this.fileUploader.mapFilesBase64.forEach((value, key) => {
      this.service.lgpd.value.files.push({
        nomeArquivo: key,
        conteudo: value
      });
    });
  }

  tratarMensagemDeErro() {
    let campos: String[] = [];
    let contrutorLgpdVO: any = LgpdVO.prototype.constructor;
    Object.values(this.service.lgpd.controls).forEach((value: AbstractControl) => {
      if (!value.valid) {
        const formGroup = value.parent.controls;
        campos.push("\n" + contrutorLgpdVO.descricaoAtributos[Object.keys(formGroup).find(name => value === formGroup[name])]);
      }
    });
    return campos;
  }

  changeAssunto(item) {
    this.service.lgpd.controls.assunto.setValue(item);

    this.service.lgpd.value.listaClassificacaoCompleta
      .map(item => item.selecionado = false);

    this.service.lgpd.value.assuntos
      .filter(assunto => assunto.id === item.id)
      .forEach((assunto: any) => assunto.selected = true);

    this.service.lgpd.value.assuntos
      .filter(assunto => assunto.id !== item.id)
      .forEach((assunto: any) => assunto.selected = false);

    this.resetFormControl();
  }

  resetFormControl() {
    this.service.lgpd.controls.descricaoLgpd.setValue('');
  }

  zeraListaClassificacao() {
    this.service.lgpd.value.listaClassificacao = [];
  }

  desmarcarCheckOutrosAssuntos() {
    this.service.lgpd.value.listaClassificacaoCompleta
      .map(item => item.selecionado = false);
    this.service.lgpd.controls.descricaoLgpd.reset();
  }

  isChecked(item) {
    return this.service.lgpd.controls.assunto.value == item;
  }

  contemErro(str) {
    return this.service.lgpd.controls[str].touched &&
      this.service.lgpd.controls[str].errors != null;
  }

  countChar(valor, max) {
    this.charNum = max - valor.length;
  }

}
